import { StyleSystemProps } from '@withjoy/joykit';

export const helperTextBadgeStyles: StyleSystemProps = {
  color: 'info6',
  backgroundColor: 'warning2',
  borderRadius: 2,
  paddingX: 3,
  paddingY: 1,
  marginTop: 4,
  width: 'fit-content',
};

export const helperTextInlineStyles: StyleSystemProps = {
  color: 'negative6',
};

export const helperTextHeadStyles: StyleSystemProps = {
  fontWeight: 'semibold',
  fontSize: '400',
  textTransform: 'uppercase',
  color: 'mono10',
  paddingBottom: 5,
};

export const styles = {
  helperTextBadge: helperTextBadgeStyles,
  helperTextInline: helperTextInlineStyles,
  helperTextHead: helperTextHeadStyles,
};
